import { EncryptStorage } from "encrypt-storage";
import Config from "@/common/config";
export const encryptStorage = new EncryptStorage(Config.storageKey, {
  stateManagementUse: true,
});
